import { Button } from 'antd'
import React from 'react'
import foydalanilgan_adabiyot from '../fayl/foydalanilgan_adabiyot.pdf'

const Adabiyot = () => {
  return (
    <Button className='button'><a href={foydalanilgan_adabiyot}>Foydalanilgan adabiyot</a></Button>
  )
}

export default Adabiyot